export default "uniform mat4 u_MVPMatrix;\nuniform mat4 u_ModelMatrix;\nuniform mat4 u_NormalMatrix;\n";
//# sourceMappingURL=project2.vertex.glsl.js.map